import styled from 'styled-components'

export const Image = styled.div`
    cursor: pointer;
    margin: 0 auto;
    
    div.name{
      text-align: center;
      width: 150px;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      word-break: break-word;
    }
    
    div.avatar{
      position: relative;
      width: 180px;
      height: 180px;
      margin: 20px;
    }
    
    img.avatar{
        position: absolute;
        top: 0;
        left: 0;
        width: 180px;
        height: 180px;
        border-radius: 100px;
        background-color: #fff;
    }
    
    div.icon{
      position: absolute;
      top: 70px;
      left: 70px;
      border-radius: 100px;
      padding: 10px 0;
      width: 45px;
      margin: 0 auto;
      display: block;
    }
    
    img.icon{
      width: 25px;
      height: 25px;
      display: block;
      margin: 0 auto;
    }
    
    span{
      width: 150px;
      height: 150px;
      background-color: #EDEDED;
      line-height: 150px;
      cursor: pointer;
      display: block;
    }
`

export const SmallImage = styled.div`
    cursor: pointer;
    border-radius: 30px;
    padding: 2px;
    
    &:hover{
        background-color: #EFF2F5;
    }
    
    div.name{
      text-align: center;
      width: 150px;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      word-break: break-word;
    }
    
    div.avatar{
      position: relative;
      width: 32px;
      height: 32px;
      background-color: #fff;
      border-radius: 32px;
    }
    
    img.avatar{
        position: absolute;
        top: 0;
        left: 0;
        width: 32px;
        height: 32px;
        border-radius: 100px;
    }
    
    div.icon{
      position: absolute;
      top: 40px;
      left: 40px;
      border-radius: 100px;
      background-color: #fff;
      width: 30px;
      height: 30px;
      margin: 0 auto;
      display: block;
    }
    
    img.icon{
      width: 14px;
      height: 12px;
      display: block;
      margin: 0 auto;
      position: absolute;
      left: 8px;
      top: 8px;
    }
    
    span{
      width: 150px;
      height: 150px;
      background-color: #EDEDED;
      line-height: 150px;
      cursor: pointer;
      display: block;
    }
`